/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>修改品牌银行卡信息 - {{serv.groupName}} </el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search"></el-form>

    <el-form label-width="120px" :model="serv" ref="serv">
      <el-form-item label="名称" prop="name">
        <el-input size="small" disabled v-model="serv.groupName" auto-complete="off" placeholder="请输入品牌名称"></el-input>
      </el-form-item>
      <el-form-item label="开户名" prop="bank_info1">
        <el-input size="small" disabled v-model="serv.bankInfo1[2]" auto-complete="off" placeholder="请输入开户名"></el-input>
      </el-form-item>
      <el-form-item label="账号" prop="bank_info3">
        <el-input size="small" disabled v-model="serv.bankInfo1[1]" auto-complete="off" placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item label="开户行" prop="bank_info2">
        <el-input size="small" disabled v-model="serv.bankInfo1[0]" auto-complete="off" placeholder="请输入开户行">
        </el-input>
      </el-form-item>
      <el-form-item label="续储公司" prop="corpId">
        <el-select disabled v-model="serv.corpId" placeholder="请选择" size="small">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="需要修改开户名" prop="bank_info1">
        <el-input size="small" v-model="serv2.bankInfo1[2]" auto-complete="off" placeholder="请输入开户名"></el-input>
      </el-form-item>
      <el-form-item label="需要修改账号" prop="bank_info3">
        <el-input size="small" v-model="serv2.bankInfo1[1]" auto-complete="off" placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item label="需要修改开户行" prop="bank_info2">
        <el-input size="small" disabled v-model="serv2.bankInfo1[0]" auto-complete="off" placeholder="请输入开户行">
        </el-input>
      </el-form-item>
      <el-form-item prop="bank_info2">
        <el-button size="small" @click="xg1 = 1">修改开户行</el-button>
      </el-form-item>

      <el-form-item label="城市" prop="bank_info2" v-if="xg1 == 1">
        <el-select v-model="province_code" placeholder="请选择城市" @change=citylist>
          <el-option v-for="item in province1" :key="item.id" :label="item.name" :value="item.provinceCode">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区域" prop="bank_info2" v-if="province_code != ''">
        <el-select v-model="city_code" placeholder="请选择区域">
          <el-option v-for="item in city1" :key="item.cityCode" :label="item.name" :value="item.cityCode">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分行" prop="bank_info2" v-if="city_code != ''">
        <el-select style="width:100%" v-model="bank_id" filterable remote placeholder="请输入关键词" size="medium"
          :remote-method="remoteMethod" @change=remoteMethod1()>
          <el-option v-for="item in branchlist" :key="item.bankId" :label="item.branchName" :value="item.bankId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="修改续储公司" prop="corpId">
        <el-select v-model="serv2.corpId" placeholder="请选择" size="small">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer" style="display: flex; justify-content: center;">
      <el-button size="small" @click="$router.back(-1)">取消</el-button>
      <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存
      </el-button>
    </div>

  </div>
</template>

<script>
  import {
    getBankBranchList,
    getBankCode,
    getCityPage,
    getProvincePage,
    getMerchantGroupDetail,
    updateGroupBank,
    investorCompany
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        xg1: 0,
        editForm: {
          bank_info: '',
          branch_name: '',
          bank_id: '',
          token: localStorage.getItem('logintoken')
        },
        options: [

         
        ],
        title: '添加',
        province1: [],
        province_code: '',
        city1: [],
        city_code: '',
        bankCode: '',
        branchlist: [],
        bank_id: '',
        mchId: this.$route.query.id,
        serv: '',
        serv2: '',
        bankCardNo: ''
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getProvincePage()

      this.merchantDetail()
      this.investorCompany()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {


      investorCompany() {
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
        }
        investorCompany(pro).then(res => {
          this.options = res.data
        })
      },
      // 获取公司列表
      merchantDetail() {
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "groupId": this.mchId
        }
        getMerchantGroupDetail(pro).then(res => {
          if (res.data.bankInfo) {
            res.data.bankInfo1 = res.data.bankInfo.split('|')
          } else {
            res.data.bankInfo1 = ['', '', '', '']
          }
          this.serv = JSON.parse(JSON.stringify(res.data))
          this.serv2 = JSON.parse(JSON.stringify(res.data))
          this.branch_name = res.data.bankInfo1[0]
          this.bankCardNo = res.data.bankInfo1[1]
          this.bank_id = res.data.bankInfo1[3]
          this.binlist()
        })
      },
      getProvincePage() {
        let pro = {}
        getProvincePage(pro).then(res => {

          this.province1 = res.data
        })
      },
      citylist() {
        let pro = {
          "provinceCode": this.province_code
        }
        console.log(this.province_code)
        getCityPage(pro).then(res => {
          this.city1 = res.data
        })
      },

      remoteMethod1() {
        this.branchlist.forEach((item) => {
          if (item.bankId == this.bank_id) {
            this.serv2.bankInfo1[0] = item.branchName
            return
          }
        })
      },
      remoteMethod(query) {
        let zf = ''
        this.branchlist = []
        let pro = {
          "cityCode": this.city_code,
          "bankCode": '',
          "bankName": query
        }
        getBankBranchList(pro).then((res) => {
          this.branchlist = res.data
          console.log(this.branchlist)

        })
      },
      submitForm() {
        if (this.bank_id == '') {
          this.$message({
            message: '请选择分行信息',
            type: 'warning'
          });
        }
        let bank_info =
          this.serv2.bankInfo1[0] + '|' + this.serv2.bankInfo1[1] + '|' + this.serv2.bankInfo1[2] + '|' + this.bank_id
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "fundsId": this.mchId,
          "bankInfo": bank_info,
          "corpId": this.serv2.corpId
        }
        updateGroupBank(pro).then((res) => {
          if (res.code == 0) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.$router.push({
              name: '品牌管理'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
      }

    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/group/groupBankCard.vue